// extracted by mini-css-extract-plugin
var _1 = "ZL4lY9sdVlnHH3fFLBjg";
var _2 = "aeKsGqXPHdrE0WY3PvNQ";
var _3 = "JUiqxJrIdk5Cb0HeuOHD";
var _4 = "ZL4lY9sdVlnHH3fFLBjg";
var _5 = "aeKsGqXPHdrE0WY3PvNQ";
var _6 = "JUiqxJrIdk5Cb0HeuOHD";
var _7 = "iXkt2eWS49IT12Uxsq6w";
var _8 = "iXkt2eWS49IT12Uxsq6w";
var _9 = "iUl_HXFTpTQkJdNhA7BD";
var _a = "phmtiXH5Wfw2mZZXgAg_";
var _b = "phmtiXH5Wfw2mZZXgAg_";
var _c = "yOlyTS4jJkhGpJvb2Hig";
export { _1 as "contact-detail-heading", _2 as "contact-email", _3 as "contact-number", _4 as "contactDetailHeading", _5 as "contactEmail", _6 as "contactNumber", _7 as "form-bottom-margin", _8 as "formBottomMargin", _9 as "minimum", _a as "no-bottom-padding", _b as "noBottomPadding", _c as "title" }
